import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../components/Svg/SvgIcon';

/* eslint-disable indent */

const SvgIcon24 = (
  {
    viewbox,
    ...others
  },
) => (
  <SvgIcon
    viewbox={viewbox}
    {...others}
  />
  );


SvgIcon24.propTypes = {
  viewbox: PropTypes.string,
};
SvgIcon24.defaultProps = {
  viewbox: '0 0 24 24',
};
export default SvgIcon24;
